'use strict';

class ChecksController {
    /* @ngInject */
    constructor(
        ChecksService,
        ClientsService,
        $scope,
        $q,
        $filter
    ) {
        Object.assign(this, {
            ChecksService,
            ClientsService,
            $scope,
            $q,
            $filter
        });

        this.query = {
            include: ['client'],
            where: {},
            limit: 10,
            page: 1,
            order: 'date DESC'
        };

        this.getChecks();

        this.onPagination = () => {
            this.getChecks();
        };
    }

    getChecks() {
        let qOpts = JSON.parse(JSON.stringify(this.query));

        if (this.client) {
            qOpts.where = Object.assign(qOpts.where, {
                clientId: this.client.id
            });
        }
        if (this.bankOrNumber) {
            qOpts.where = Object.assign(qOpts.where, {
                or: [
                    {
                        bank: {
                            ilike: `%${this.bankOrNumber}%`
                        }
                    },
                    {
                        number: {
                            ilike: `%${this.bankOrNumber}%`
                        }
                    }
                ]
            });
        }

        if (this.onlyNotDeposited) {
            qOpts.where = Object.assign(qOpts.where, {
                depositedAt: null
            });
        }
        if (this.onlyNotCredited) {
            qOpts.where = Object.assign(qOpts.where, {
                creditedAt: null
            });
        }

        let queryReady = this.ChecksService
            .getModels(qOpts)
            .then(checks => {
                this.checks = checks;
            });
        let countReady = this.ChecksService
            .getCount(qOpts)
            .then(result => {
                this.checksCount = result.count;
            });
        this.promise = this.$q.all([queryReady, countReady]);
        return this.promise;
    }

    querySearchClient() {
        return this.ClientsService.findByName(this.searchTextClient);
    }
}

export default ChecksController;
